export default {
  signIn: 'Anmelden',
  signOut: 'Abmelden',
  points: 'Punkte',
  hyattSignInButton: 'Melden Sie sich bei World of Hyatt an',
};
